export { default } from './Typografed';
